// @flow

import React from 'react';
import styled from 'styled-components';

import WidthContainer from '../WidthContainer';

import Menu from './partials/Menu/container';
import Logo from './partials/Logo/index';

const Background = styled.header`
  position: relative;
  width: 100%;
  background-color: #313238;
`;

const Wrapper = styled.div`
  display: flex;
  min-height: 76px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: white;
`;

const Header = () => (
  <Background>
    <WidthContainer>
      <Wrapper>
        <Logo />
        <Menu />
      </Wrapper>
    </WidthContainer>
  </Background>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js